import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
export const LiskLogo = ({ size = 16, className }) => {
    return (_jsxs("svg", { viewBox: "0 0 229.1 259", className: clsx("inline ml-1 mb-[3px]", className), width: size, height: size, children: [_jsx("path", { d: "m115.4 0-25.9 42.9 85.2 139.6-71.3 76.5h60.4l66.3-71.1z", fill: "#e84d31" }), _jsx("path", { d: "m87.6 215.9-31.1-33.4 52.3-85.9-26.1-42.7-81.7 134 66.3 71.1h22l40.4-43.1z", fill: "#e84d31" })] }));
};
